import {
  Box,
  MenuItem,
  Select,
  Typography,
  IconButton,
  Tooltip,
} from '@mui/material';
import { useState, useEffect, useRef } from 'react';
import LayoutWithSidebar from '../../components/common/layoutWithSidebar';
import { HeaderContainer } from '../../components/dashboard/AgentInfoHeader';
import { ArrowClockwise } from '@phosphor-icons/react';
import AvaiableSeatsTable from '../../components/KnowledgeBase/Reservation/AvaiableSeatsTable';
import { keyframes } from '@emotion/react';
import { useStores } from '../../components/UserJourny/FirstUserJourney/useStores';

const rotateAnimation = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

const Reservation = ({
  store,
  fromStoreDetails = false,
}: {
  store?: any;
  fromStoreDetails?: boolean;
}) => {
  const [isRefreshing, setIsRefreshing] = useState(false);
  const tableRef = useRef(null);

  const { storesList, storesListLoading } = useStores();

  const [selectedStore, setSelectedStore] = useState<any>(null);

  useEffect(() => {
    if (storesList?.length > 0 && !selectedStore) {
      setSelectedStore(storesList[0]);
    }
  }, [storesList, selectedStore]);

  useEffect(() => {
    if (selectedStore && storesList?.length > 0) {
      const updatedStore = storesList.find(
        (store: any) => store.id === selectedStore.id
      );
      if (updatedStore) {
        setSelectedStore(updatedStore);
      }
    }
  }, [storesList, selectedStore]);

  const handleStoreChange = (e: any) => {
    const selectedStore = storesList.find(
      (store: any) => store.friendly_name === e.target.value
    );
    setSelectedStore(selectedStore);
    setIsRefreshing(true);
    if (tableRef.current) {
      (tableRef.current as any).refresh().finally(() => {
        setIsRefreshing(false);
      });
    }
  };

  const handleRefresh = () => {
    setIsRefreshing(true);
    if (tableRef.current) {
      (tableRef.current as any).refresh();
    }
  };

  return (
    <>
      {!fromStoreDetails ? (
        <LayoutWithSidebar margin={2}>
          <HeaderContainer>
            <Typography
              sx={{
                fontFamily: 'DM Sans',
                fontWeight: 600,
                fontSize: '24px',
                lineHeight: '100%',
                letterSpacing: '-0.01em',
                color: '#2B2D3F',
              }}
            >
              Reservation Slots
            </Typography>
            <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
              <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                <Typography
                  fontSize={12}
                  fontWeight={400}
                  color="text.secondary"
                >
                  Select Store
                </Typography>
                <Select
                  sx={{ width: 136, height: 34 }}
                  value={selectedStore?.friendly_name || ''}
                  onChange={handleStoreChange}
                  displayEmpty
                  disabled={storesListLoading}
                >
                  {storesList?.map((store: any) => (
                    <MenuItem key={store.id} value={store.friendly_name}>
                      {store.friendly_name}
                    </MenuItem>
                  ))}
                </Select>
              </Box>
              <Tooltip title="Refresh">
                <IconButton
                  color="primary"
                  onClick={handleRefresh}
                  disabled={isRefreshing}
                  sx={{
                    width: 34,
                    height: 34,
                    backgroundColor: '#F4F7FF',
                    mr: 1,
                    color: '#000000',
                    borderRadius: '6px',
                    '&:hover': {
                      backgroundColor: 'rgba(0, 0, 0, 0.04)',
                    },
                    '& svg': {
                      animation: isRefreshing
                        ? `${rotateAnimation} 1s linear infinite`
                        : 'none',
                    },
                  }}
                >
                  <ArrowClockwise size={20} weight="bold" />
                </IconButton>
              </Tooltip>
            </Box>
          </HeaderContainer>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: 2,
              borderRadius: '12px',
              border: '1px solid #DCE0E7',
              backgroundColor: '#FFFFFF',
              height: '100%',
              width: '100%',
              p: '24px',
              cursor: 'context-menu',
              overflowY: 'scroll',
              scrollbarWidth: 'none',
            }}
          >
            <AvaiableSeatsTable
              selectedStore={selectedStore}
              isStoreLoading={storesListLoading}
              ref={tableRef}
              onRefreshStart={() => setIsRefreshing(true)}
              onRefreshComplete={() => setIsRefreshing(false)}
            />
          </Box>
        </LayoutWithSidebar>
      ) : (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
            backgroundColor: '#FFFFFF',
            height: '100%',
            width: '100%',
            p: '24px',
            cursor: 'context-menu',
            overflowY: 'scroll',
            scrollbarWidth: 'none',
          }}
        >
          <AvaiableSeatsTable
            selectedStore={fromStoreDetails ? store : selectedStore}
            isStoreLoading={storesListLoading}
            ref={tableRef}
            onRefreshStart={() => setIsRefreshing(true)}
            onRefreshComplete={() => setIsRefreshing(false)}
          />
        </Box>
      )}
    </>
  );
};

export default Reservation;
